function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.82 3.6c.12.06.18.16.18.304V5.27c0 .09-.027.167-.081.233a.257.257 0 0 1-.208.099H.28a.248.248 0 0 1-.199-.099A.356.356 0 0 1 0 5.27V3.904c0-.143.06-.245.18-.305l1.246-.574.487-.225a1.328 1.328 0 0 1-.523-.592 1.596 1.596 0 0 1-.108-1.158 1.54 1.54 0 0 1 .455-.754C1.957.1 2.211 0 2.5 0c.295 0 .554.102.776.305.223.204.373.46.451.772a1.716 1.716 0 0 1-.099 1.095c-.12.27-.295.473-.523.61l.514.243 1.2.574z"
});

var SvgIconUser = function SvgIconUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-user",
    width: 5,
    height: 6,
    fill: "#4859EE",
    viewBox: "0 0 5 6",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-user.6e0e3398.svg";
export { ForwardRef as ReactComponent };